export const PAGE_SIZE = {
	TEN: "10",
	FIFTY: "50",
	HUNDRED: "100",
	INFINITE: "-1" // used for infinite scrolling
};